var React = require('react');

function Address (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3 18C1.34315 18 0 16.8888 0 15.5181V7.24499C0 7.21695 0.00169009 7.18923 0.00498009 7.1619H0C0 6.6854 0.2288 6.22842 0.63607 5.89148L6.87868 0.726938C8.0502 -0.242313 9.9497 -0.242313 11.1213 0.726938L17.3639 5.8915C17.7712 6.22842 18 6.6854 18 7.1619H17.995C17.9983 7.18923 18 7.21695 18 7.24499V15.5181C18 16.8888 16.6569 18 15 18H3ZM9.7071 1.89692L16 7.10308V15.5181C16 15.9749 15.5523 16.3454 15 16.3454H12V12.2089C12 10.8381 10.6569 9.72694 9 9.72694C7.3431 9.72694 6 10.8381 6 12.2089V16.3454H3C2.44772 16.3454 2 15.9749 2 15.5181V7.10314L8.2929 1.89692C8.6834 1.57384 9.3166 1.57384 9.7071 1.89692Z","fill":"#3A9A9F"}));
}

Address.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Address;

Address.default = Address;
